<template>
	<wt-selector :options="options" v-model="Value" :disabled="disabled"></wt-selector>
</template>
<script>
import { packageProductTypes } from 'json/lab-order'
export default {
  name: 'package-product-type-selector',
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      Value: this.value,
      options: this.change(packageProductTypes)
    }
  },
  watch: {
    value (val) {
      this.Value = val
    },
    Value (val) {
      this.$emit('input', this.Value)
    }
  },
  methods: {
    change (arr) {
      var newArr = []
      arr.forEach(ele => {
        var obj = {}
        obj.value = ele.key
        obj.label = ele.value
        newArr.push(obj)
      })
      return newArr
    }
  },
  created () {
  }
}
</script>
